
<div class="general-error-container" (click)="onOverlayClick($event)">
  <div class="inner">
    <div class="close-btn-container">

      <div class="close-btn-mobile" (click)="onClosePopup()">
        <img alt="Close" src="/assets/icons/close-icon.svg">
      </div>

    </div>

      <div class="error-content">
        <div class="title">
          <span fiTranslation="GENERAL_ERROR_HEADLINE"></span>
        </div>
        <div class="description">
          <span fiTranslation="GENERAL_ERROR_TEXT"></span>
        </div>
      </div>
  </div>

</div>
